"use client";

import "@ivandt/importer/importer";
import type { DefaultTableRowType, IvtSchema } from "@ivandt/importer";

export interface IvtImporterProps<TableRow = DefaultTableRowType> {
  schema: IvtSchema<TableRow>;
  // Styling
  className?: string;
  style?: React.CSSProperties;
}

export default function IvtImporter<TableRow = DefaultTableRowType>({
  className,
  style,
  schema,
}: IvtImporterProps<TableRow>) {
  return (
    // @ts-expect-error - web component
    <ivt-importer schema={schema} className={className} style={style} />
  );
}

export interface IvtImporterRef {
  element: HTMLElement | null;
}
